import angular from 'angular';

export default angular
  .module('csm.ui.initFocus', [])
  .directive('initFocus', initFocusDirective)
  .name;

initFocusDirective.$inject = [];
  
/*****************************************************************************
 * Directive: initFocus */
/**
 * @description
 * Sets on this element when it links by calling the focus method of the DOM
 * element. The priority is set to a high value as the post-link functions are
 * executed in reverse priority order.
 *
 * This is deprecated and usage should be replaced with csmFocus
 *****************************************************************************/
/* @ngInject */
function initFocusDirective() {
  return {
    restrict: 'A',
    priority: 1000,
    link: function (scope, element) {
      element[0].focus();
    }
  };
}